import entities from '../entities/sagas';
import notifications from '../components/Notifications/sagas';
import viewCustomerSagas from '../Customers/View/sagas';
import viewResourceSagas from '../Resources/View/sagas';

export default [
  ...entities,
  notifications,
  viewCustomerSagas,
  viewResourceSagas,
];
